import { useQuery } from '@tanstack/react-query'
import { usuarioLogadoQueryGql } from '../data/usuario-logado'
import type { GetUsuarioLogadoQueryQuery } from '@/core/types/graphql'
import { request } from '../utils/request'

export const useUsuarioLogado = () => {
  const { data: { usuarioLogado } = {}, isLoading } = useQuery({
    queryKey: ['usuarioLogado'],
    queryFn: async () =>
      await request<GetUsuarioLogadoQueryQuery>(usuarioLogadoQueryGql)
  })

  return { usuarioLogado, isLoading }
}
